import { Box } from "components";
import styled from "styled-components";

export const Canvas = styled(Box)`
  ${({ theme: { colors } }) => `
  background: ${colors("background")};
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`}
`;

export const Puck = styled(Box)`
  ${({ theme: { colors, defaults } }) => `
    padding: 1rem;
    background: ${colors("chrome")};
    border-radius: ${defaults("radius")};
  `}
`;

export const QRContainer = styled(Box)`
  border: 0.5rem solid #fff;
  width: 25vw;
`;

export const Player = styled.video`
  ${({ theme: { colors } }) => `
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: ${colors("chrome")};
`}
`;

export const MiniQROverlay = styled(Box)`
  ${({ theme: { colors, defaults } }) => `
    position: absolute;
    bottom: 1rem;
    left: 1rem;
    z-index: 100000;
    padding: 0.5rem;
    background: ${colors("chrome", 0.8)};
    border-radius: ${defaults("radius")};
  `}
`;
